module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_text":"Update Text"},"id":{"update_text":"Perbarui Teks"}}')
  delete Component.options._Ctor
}
